import SvgIcon from '@mui/material/SvgIcon';
import { DIM_GRAY } from 'utils/theme';

const CheckboxEmptyIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 17"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        fontSize: props.width ?? '16px',
      }}
    >
      <path
        fill="none"
        stroke={DIM_GRAY}
        strokeOpacity="0.6"
        d="M13.5 1.2168H2.5C1.39543 1.2168 0.5 2.11223 0.5 3.2168V14.2168C0.5 15.3214 1.39543 16.2168 2.5 16.2168H13.5C14.6046 16.2168 15.5 15.3214 15.5 14.2168V3.2168C15.5 2.11223 14.6046 1.2168 13.5 1.2168Z"
      ></path>
    </SvgIcon>
  );
};

export default CheckboxEmptyIcon;
